import React, { useState, useEffect } from 'react';
// import styles from './AdvancedBasicRCRA.module.scss';
import styles from '../../../BasicCleanupsFilter/BasicCleanupsFilter.module.scss';
import { CalciteCheckbox } from '@esri/calcite-components-react';


/*
the options object stores objects with attributes for:
  - what to label the checkbox with
  - what parameter to query for when a box is checkbox
  - the objectIds returned from the query (query is only done the first time the box is checked)
*/
const options = {
  "Current Corrective Action": {
    param: "RCRA_CURRENT_IND='Y'",
    isIncluded: false,
    objectIds: null
  },
  "Remedy Selected": {
    param: "RCRA_REMEDY_SEL_IND='Y'",
    isIncluded: false,
    objectIds: null
  },
  "Construction Complete": {
    param: "RCRA_CONSTR_COMPLT_IND='Y'",
    isIncluded: false,
    objectIds: null
  },
  "Remedy Action Complete": {
    param: "RCRA_REMEDY_COMPLT_IND='Y'",
    isIncluded: false,
    objectIds: null
  },
  "Remedy Not Yet Selected": {
    param: "RCRA_REMEDY_NOT_SEL_IND='Y'",
    isIncluded: false,
    objectIds: null
  },
  "Ready for Anticipated Use": {
    param: "RCRA_RAU_IND = 'Y'",
    isIncluded: false,
    objectIds: null
  }
};

const AdvancedBasicRCRA = (props) => {
  const [checkboxDivArray, setCheckboxDivArray] = useState<Array<any>>([]);
  /* called every time a checkbox is checked or unchecked */
  const toggleParam = async (key) => {
    options[key].isIncluded = !options[key].isIncluded;
    passUpdatedParams();
  }

  // updates the brownfieldParam array stored in the parent component
  const passUpdatedParams = () => {
    let paramArray: Array<string> = [];
    for (let option in options) {
      if (options[option].isIncluded === true) {
        paramArray.push(options[option].param)
      }
    }
    // update the parameter stored in the parent component
    props.updateRCRAParams(paramArray);
  }

  const buildCheckboxDivs = (clear?) => {
    let tempArr: Array<any> = [];
    if (clear) {
      // the clear button was clicked, recreate checkboxes to be all unchecked
      for (let key in options) {
        options[key]["isIncluded"] = false;
        tempArr.push(
          <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
            <CalciteCheckbox name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
            <label className={styles.CheckboxLabels}>{key}</label>
          </div>
        );
      }
    } else {
      for (let key in options) {
        // clear button was not clicked, create checkboxes so that previously checked are still checked
        if (options[key]["isIncluded"] === true) {
          tempArr.push(
            <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
              <CalciteCheckbox checked name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
              <label className={styles.CheckboxLabels}>{key}</label>
            </div>
          );
        } else {
          tempArr.push(
            <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
              <CalciteCheckbox name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
              <label className={styles.CheckboxLabels}>{key}</label>
            </div>
          );
        }
      }
    }
    passUpdatedParams();
    setCheckboxDivArray(tempArr);
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { buildCheckboxDivs(); }, [props.matchesAny]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { buildCheckboxDivs(true); }, [props.signalClear]);

  return (
    <div className={styles.Sections}>
      <div className={styles.SectionTitleDivs}>
        <label className={styles.FilterSectionLabels}>Hazardous Waste Corrective Action</label>
      </div>
      <div className={styles.CheckboxSectionDivs}>
        {checkboxDivArray}
      </div>
    </div>
  );
}
export default AdvancedBasicRCRA;
